import axios from "axios";

export class UserServices {
    private readonly url: string = "/api/user";

    public async GetUserByRole(role: string) {
        const response = await axios.get(this.url, { params: { role } });
        return response;
    }
}